import { withBemMod } from '@bem-react/core';
import { cnButton } from '@yandex-int/hr-components/Button';

import './Button_view_legal.css';

export type WithViewLegalProps = {
    view?: 'legal';
};

export const withViewLegal = withBemMod<WithViewLegalProps>(cnButton(), {
    view: 'legal',
});
